import { yupResolver } from '@hookform/resolvers/yup'
import React from 'react'
import { Create } from 'react-admin'
import { couponVS } from 'services/validations/coupons'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import CouponForm from './CouponForm'

const CouponCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create>
        <CouponForm resolver={yupResolver(couponVS)} />
      </Create>
    </SectionWrapper>
  )
}

export default CouponCreate
